// Kundenkonto (Anmeldung, Konto, Stufen, Checkout-Auswahl). Flache Schlüssel ca_*, wird in fieldMapping.js eingemischt.
const de = {
  ca_salutation: "Anrede",
  ca_title: "Titel",
  ca_mr: "Herr",
  ca_mrs: "Frau",
  ca_diverse: "Divers",
  ca_name: "Name",
  ca_profile_hint: "Diese Daten werden bei jeder Buchung automatisch übernommen und können dort nicht geändert werden – ändere sie hier.",
  ca_addresses: "Meine Adressen",
  ca_addresses_hint: "Bei der Buchung wählst du eine dieser Adressen aus.",
  ca_address: "Adresse",
  ca_address_add: "Adresse hinzufügen",
  ca_address_edit: "Adresse bearbeiten",
  ca_address_label: "Bezeichnung (optional)",
  ca_address_label_ph: "z. B. Zuhause, Büro",
  ca_street: "Straße",
  ca_house_no: "Nr.",
  ca_zip: "PLZ",
  ca_city: "Ort",
  ca_country: "Land",
  ca_address_default: "Als Standardadresse verwenden",
  ca_default: "Standard",
  ca_make_default: "Als Standard festlegen",
  ca_edit: "Bearbeiten",
  ca_delete: "Löschen",
  ca_no_addresses: "Noch keine Adresse gespeichert.",
  ca_address_delete_q: "Adresse löschen?",
  ca_account_data: "Deine Daten aus dem Konto",
  ca_account_data_desc: "Diese Angaben kommen aus deinem Konto und können hier nicht geändert werden.",
  ca_change_in_account: "Ändern kannst du sie nur im Konto.",
  ca_open_account: "Mein Konto öffnen",
  ca_missing_data: "Bitte ergänze in deinem Konto",
  ca_pick_address: "Adresse wählen",
  ca_pick_address_desc: "Wähle eine gespeicherte Adresse oder füge eine neue hinzu.",
  ca_error: "Etwas ist schiefgelaufen. Bitte versuche es erneut.",
  ca_loading: "Wird geladen …",
  ca_checking: "Wird geprüft …",
  ca_cancel: "Abbrechen",
  ca_confirm: "Bestätigen",
  ca_save: "Speichern",
  ca_saved: "Gespart",
  ca_saved_ok: "Gespeichert.",
  ca_done: "Fertig",
  ca_copy: "Kopieren",
  ca_download: "Alle Codes herunterladen",
  ca_or: "oder",
  ca_login: "Anmelden",
  ca_register: "Registrieren",
  ca_logout: "Abmelden",
  ca_logout_q: "Abmelden?",
  ca_logout_text: "Du wirst auf diesem Gerät abgemeldet.",
  ca_login_passkey: "Mit Passkey anmelden",
  ca_create_account: "Konto erstellen",
  ca_my_account: "Mein Konto",
  ca_hello: "Hallo",
  ca_email: "E-Mail-Adresse",
  ca_first_name: "Vorname",
  ca_last_name: "Nachname",
  ca_phone: "Telefon",
  ca_password: "Passwort",
  ca_password_repeat: "Passwort wiederholen",
  ca_current_password: "Aktuelles Passwort",
  ca_new_password: "Neues Passwort",
  ca_new_email: "Neue E-Mail-Adresse",
  ca_pw_rules: "Mindestens 8 Zeichen, mit Buchstaben und Zahl.",
  ca_pw_mismatch: "Die Passwörter stimmen nicht überein.",
  ca_pw_changed: "Passwort geändert.",
  ca_change_password: "Passwort ändern",
  ca_forgot: "Passwort vergessen?",
  ca_forgot_title: "Passwort vergessen",
  ca_forgot_text: "Gib deine E-Mail-Adresse ein. Wir senden dir einen Link zum Zurücksetzen.",
  ca_forgot_done: "Falls es ein Konto mit dieser Adresse gibt, haben wir dir einen Link gesendet.",
  ca_send_link: "Link senden",
  ca_back_login: "Zurück zur Anmeldung",
  ca_reset_title: "Neues Passwort festlegen",
  ca_reset_done: "Dein Passwort wurde geändert. Alle Geräte wurden abgemeldet. Du wirst zur Anmeldung weitergeleitet …",
  ca_save_password: "Passwort speichern",
  ca_agb_prefix: "Ich akzeptiere die",
  ca_agb: "AGB",
  ca_and: "und die",
  ca_privacy: "Datenschutzerklärung",
  ca_agb_required: "Bitte AGB und Datenschutzerklärung akzeptieren.",
  ca_verified_title: "E-Mail-Adresse bestätigt",
  ca_verified_text: "Danke! Dein Konto ist freigeschaltet, deine bisherigen Buchungen findest du jetzt unter „Mein Konto“.",
  ca_to_account: "Zu meinem Konto",
  ca_link_invalid: "Link ungültig oder abgelaufen",
  ca_email_changed_title: "E-Mail-Adresse geändert",
  ca_email_changed_text: "Deine E-Mail-Adresse wurde geändert. {n} Buchung(en) wurden auf die neue Adresse umgestellt. Bitte melde dich neu an.",
  ca_email_change_hint: "Wir senden einen Bestätigungslink an die neue Adresse. Danach werden auch deine Buchungen auf die neue Adresse umgestellt.",
  ca_change_email: "E-Mail-Adresse ändern",
  ca_send_confirm_link: "Bestätigungslink senden",
  ca_email_change_sent: "Wir haben einen Bestätigungslink an die neue Adresse gesendet.",
  ca_banner_verify: "Bitte bestätige deine E-Mail-Adresse – wir haben dir eine Mail gesendet. Erst dann siehst du deine Buchungen und sammelst Punkte.",
  ca_resend: "Mail erneut senden",
  ca_resent: "Bestätigungsmail wurde erneut gesendet.",
  ca_verify_needed: "E-Mail-Adresse bestätigen",
  ca_verify_needed_text: "Sobald du deine E-Mail-Adresse bestätigt hast, erscheinen hier alle deine Buchungen – auch ältere mit derselben Adresse.",
  ca_security_verify_text: "Bitte bestätige zuerst deine E-Mail-Adresse, um Zwei-Faktor und Passkeys einzurichten.",
  ca_my_bookings: "Meine Buchungen",
  ca_profile: "Profil",
  ca_security: "Sicherheit",
  ca_upcoming: "Anstehend",
  ca_past: "Vergangen",
  ca_all: "Alle",
  ca_no_bookings: "Keine Buchungen in dieser Ansicht.",
  ca_manage: "Verwalten",
  ca_round_trip: "Hin- & Rückfahrt",
  ca_st_planned: "Angefragt",
  ca_st_planned_accept: "Angebot angenommen",
  ca_st_waiting: "Wird zugewiesen",
  ca_st_approved: "Bestätigt",
  ca_st_en_route: "Fahrer unterwegs",
  ca_st_arrived: "Fahrer vor Ort",
  ca_st_onboard: "Fahrt läuft",
  ca_st_completed: "Abgeschlossen",
  ca_st_cancelled: "Storniert",
  ca_st_storno: "Storniert",
  ca_st_noshow: "Nicht angetroffen",
  ca_st_reklamiert: "Reklamiert",
  ca_points: "Punkte",
  ca_tier_active: "Dein Rabatt: {p} % auf alle Fahrten – automatisch in den Angeboten.",
  ca_tier_basic_text: "Sammle Punkte mit jeder abgeschlossenen Fahrt und steige auf – bis zu 7 % Rabatt.",
  ca_tier_next: "Noch {n} Punkte bis {name} ({p} % Rabatt)",
  ca_tier_next_trips: "Noch ca. {trips} Fahrten bis {name} ({p} % Rabatt) · {n} Punkte",
  ca_tier_next_trip: "Noch ca. 1 Fahrt bis {name} ({p} % Rabatt) · {n} Punkte",
  ca_tier_max: "Du hast die höchste Stufe erreicht. 🎉",
  ca_tier_discount: "Stufen-Rabatt",
  ca_2fa_title: "Zwei-Faktor-Anmeldung",
  ca_2fa_sub: "Schütze dein Konto mit einem zusätzlichen Code aus einer Authenticator-App.",
  ca_2fa_hint: "Gib den 6-stelligen Code aus deiner Authenticator-App ein.",
  ca_2fa_backup_hint: "Gib einen deiner Backup-Codes ein. Jeder Code gilt nur einmal.",
  ca_code: "Code",
  ca_backup_code: "Backup-Code",
  ca_code_or_backup: "Code aus der App oder Backup-Code",
  ca_use_backup: "Handy nicht zur Hand? Backup-Code verwenden",
  ca_use_app_code: "Stattdessen Code aus der Authenticator-App eingeben",
  ca_2fa_on: "Zwei-Faktor ist aktiv",
  ca_2fa_off: "Zwei-Faktor ist aus",
  ca_2fa_off_text: "Mit der Zwei-Faktor-Anmeldung braucht ein Fremder neben deinem Passwort auch dein Handy.",
  ca_2fa_off_done: "Zwei-Faktor wurde ausgeschaltet.",
  ca_2fa_enable: "Aktivieren",
  ca_2fa_activate: "Bestätigen und aktivieren",
  ca_2fa_disable: "Ausschalten",
  ca_2fa_disable_text: "Zum Ausschalten brauchst du dein Passwort und einen aktuellen Code oder Backup-Code.",
  ca_2fa_scan: "1. QR-Code mit der Authenticator-App scannen. 2. Den angezeigten 6-stelligen Code unten eingeben.",
  ca_2fa_manual: "Oder manuell eingeben",
  ca_new_backup: "Neue Backup-Codes erzeugen",
  ca_backup_left: "Übrige Backup-Codes",
  ca_backup_text: "Speichere diese Backup-Codes sicher. Sie werden nur jetzt angezeigt und gelten je einmal.",
  ca_each_once: "jeder Code gilt nur einmal",
  ca_checkout_title: "Kundenkonto",
  ca_checkout_desc: "Als Gast weiter oder ein Konto erstellen – mit Konto siehst du alle Buchungen und sammelst Punkte für Rabatte.",
  ca_guest: "Als Gast fortfahren",
  ca_guest_text: "Schnell buchen ohne Konto.",
  ca_create_account_text: "Buchungen verwalten, Punkte sammeln, bis zu 7 % Rabatt.",
  ca_data_taken: "Deine Daten aus diesem Formular werden übernommen – du musst nur noch ein Passwort wählen.",
  ca_continue_guest: "Als Gast fortfahren",
  ca_logged_in_as: "Angemeldet als",
};
const en = {
  ca_salutation: "Salutation",
  ca_title: "Title",
  ca_mr: "Mr",
  ca_mrs: "Mrs",
  ca_diverse: "Diverse",
  ca_name: "Name",
  ca_profile_hint: "These details are used for every booking automatically and cannot be changed there – change them here.",
  ca_addresses: "My addresses",
  ca_addresses_hint: "When booking you pick one of these addresses.",
  ca_address: "Address",
  ca_address_add: "Add address",
  ca_address_edit: "Edit address",
  ca_address_label: "Label (optional)",
  ca_address_label_ph: "e.g. Home, Office",
  ca_street: "Street",
  ca_house_no: "No.",
  ca_zip: "ZIP",
  ca_city: "City",
  ca_country: "Country",
  ca_address_default: "Use as default address",
  ca_default: "Default",
  ca_make_default: "Make default",
  ca_edit: "Edit",
  ca_delete: "Delete",
  ca_no_addresses: "No address saved yet.",
  ca_address_delete_q: "Delete address?",
  ca_account_data: "Your details from your account",
  ca_account_data_desc: "These details come from your account and cannot be changed here.",
  ca_change_in_account: "You can change them in your account only.",
  ca_open_account: "Open my account",
  ca_missing_data: "Please complete in your account",
  ca_pick_address: "Choose address",
  ca_pick_address_desc: "Choose a saved address or add a new one.",
  ca_error: "Something went wrong. Please try again.",
  ca_loading: "Loading …",
  ca_checking: "Checking …",
  ca_cancel: "Cancel",
  ca_confirm: "Confirm",
  ca_save: "Save",
  ca_saved: "Saved",
  ca_saved_ok: "Saved.",
  ca_done: "Done",
  ca_copy: "Copy",
  ca_download: "Download all codes",
  ca_or: "or",
  ca_login: "Log in",
  ca_register: "Register",
  ca_logout: "Log out",
  ca_logout_q: "Log out?",
  ca_logout_text: "You will be logged out on this device.",
  ca_login_passkey: "Log in with passkey",
  ca_create_account: "Create account",
  ca_my_account: "My account",
  ca_hello: "Hello",
  ca_email: "Email address",
  ca_first_name: "First name",
  ca_last_name: "Last name",
  ca_phone: "Phone",
  ca_password: "Password",
  ca_password_repeat: "Repeat password",
  ca_current_password: "Current password",
  ca_new_password: "New password",
  ca_new_email: "New email address",
  ca_pw_rules: "At least 8 characters, with letters and a number.",
  ca_pw_mismatch: "The passwords do not match.",
  ca_pw_changed: "Password changed.",
  ca_change_password: "Change password",
  ca_forgot: "Forgot password?",
  ca_forgot_title: "Forgot password",
  ca_forgot_text: "Enter your email address. We will send you a reset link.",
  ca_forgot_done: "If an account with this address exists, we have sent you a link.",
  ca_send_link: "Send link",
  ca_back_login: "Back to login",
  ca_reset_title: "Set a new password",
  ca_reset_done: "Your password has been changed. All devices were logged out. Redirecting to login …",
  ca_save_password: "Save password",
  ca_agb_prefix: "I accept the",
  ca_agb: "terms and conditions",
  ca_and: "and the",
  ca_privacy: "privacy policy",
  ca_agb_required: "Please accept the terms and privacy policy.",
  ca_verified_title: "Email address confirmed",
  ca_verified_text: "Thank you! Your account is active. You can now find your previous bookings under “My account”.",
  ca_to_account: "To my account",
  ca_link_invalid: "Link invalid or expired",
  ca_email_changed_title: "Email address changed",
  ca_email_changed_text: "Your email address was changed. {n} booking(s) were moved to the new address. Please log in again.",
  ca_email_change_hint: "We send a confirmation link to the new address. Your bookings are then moved to the new address too.",
  ca_change_email: "Change email address",
  ca_send_confirm_link: "Send confirmation link",
  ca_email_change_sent: "We sent a confirmation link to the new address.",
  ca_banner_verify: "Please confirm your email address – we sent you a message. Only then you see your bookings and collect points.",
  ca_resend: "Resend email",
  ca_resent: "Confirmation email sent again.",
  ca_verify_needed: "Confirm your email address",
  ca_verify_needed_text: "Once you confirm your email address, all your bookings appear here – including older ones with the same address.",
  ca_security_verify_text: "Please confirm your email address first to set up two-factor and passkeys.",
  ca_my_bookings: "My bookings",
  ca_profile: "Profile",
  ca_security: "Security",
  ca_upcoming: "Upcoming",
  ca_past: "Past",
  ca_all: "All",
  ca_no_bookings: "No bookings in this view.",
  ca_manage: "Manage",
  ca_round_trip: "Round trip",
  ca_st_planned: "Requested",
  ca_st_planned_accept: "Offer accepted",
  ca_st_waiting: "Being assigned",
  ca_st_approved: "Confirmed",
  ca_st_en_route: "Driver on the way",
  ca_st_arrived: "Driver arrived",
  ca_st_onboard: "Trip in progress",
  ca_st_completed: "Completed",
  ca_st_cancelled: "Cancelled",
  ca_st_storno: "Cancelled",
  ca_st_noshow: "No-show",
  ca_st_reklamiert: "Complained",
  ca_points: "points",
  ca_tier_active: "Your discount: {p}% on all trips – applied automatically in the offers.",
  ca_tier_basic_text: "Collect points with every completed trip and move up – up to 7% discount.",
  ca_tier_next: "{n} more points to {name} ({p}% discount)",
  ca_tier_next_trips: "About {trips} more trips to {name} ({p}% discount) · {n} points",
  ca_tier_next_trip: "About 1 more trip to {name} ({p}% discount) · {n} points",
  ca_tier_max: "You have reached the highest tier. 🎉",
  ca_tier_discount: "Tier discount",
  ca_2fa_title: "Two-factor authentication",
  ca_2fa_sub: "Protect your account with an additional code from an authenticator app.",
  ca_2fa_hint: "Enter the 6-digit code from your authenticator app.",
  ca_2fa_backup_hint: "Enter one of your backup codes. Each code works only once.",
  ca_code: "Code",
  ca_backup_code: "Backup code",
  ca_code_or_backup: "Code from the app or backup code",
  ca_use_backup: "Phone not at hand? Use a backup code",
  ca_use_app_code: "Enter the code from the authenticator app instead",
  ca_2fa_on: "Two-factor is active",
  ca_2fa_off: "Two-factor is off",
  ca_2fa_off_text: "With two-factor authentication a stranger would need your phone as well as your password.",
  ca_2fa_off_done: "Two-factor was switched off.",
  ca_2fa_enable: "Enable",
  ca_2fa_activate: "Confirm and activate",
  ca_2fa_disable: "Switch off",
  ca_2fa_disable_text: "To switch off you need your password and a current code or backup code.",
  ca_2fa_scan: "1. Scan the QR code with your authenticator app. 2. Enter the 6-digit code below.",
  ca_2fa_manual: "Or enter manually",
  ca_new_backup: "Generate new backup codes",
  ca_backup_left: "Remaining backup codes",
  ca_backup_text: "Store these backup codes safely. They are shown only now and each works once.",
  ca_each_once: "each code works only once",
  ca_checkout_title: "Customer account",
  ca_checkout_desc: "Continue as guest or create an account – with an account you see all bookings and collect points for discounts.",
  ca_guest: "Continue as guest",
  ca_guest_text: "Book quickly without an account.",
  ca_create_account_text: "Manage bookings, collect points, up to 7% discount.",
  ca_data_taken: "Your details from this form are used – you only need to choose a password.",
  ca_continue_guest: "Continue as guest",
  ca_logged_in_as: "Logged in as",
};
const tr = {
  ca_salutation: "Hitap",
  ca_title: "Unvan",
  ca_mr: "Bay",
  ca_mrs: "Bayan",
  ca_diverse: "Diğer",
  ca_name: "Ad Soyad",
  ca_profile_hint: "Bu bilgiler her rezervasyonda otomatik kullanılır ve orada değiştirilemez – burada değiştirin.",
  ca_addresses: "Adreslerim",
  ca_addresses_hint: "Rezervasyonda bu adreslerden birini seçersiniz.",
  ca_address: "Adres",
  ca_address_add: "Adres ekle",
  ca_address_edit: "Adresi düzenle",
  ca_address_label: "Etiket (isteğe bağlı)",
  ca_address_label_ph: "örn. Ev, Ofis",
  ca_street: "Cadde",
  ca_house_no: "No.",
  ca_zip: "Posta kodu",
  ca_city: "Şehir",
  ca_country: "Ülke",
  ca_address_default: "Varsayılan adres yap",
  ca_default: "Varsayılan",
  ca_make_default: "Varsayılan yap",
  ca_edit: "Düzenle",
  ca_delete: "Sil",
  ca_no_addresses: "Henüz adres kaydedilmedi.",
  ca_address_delete_q: "Adres silinsin mi?",
  ca_account_data: "Hesabınızdaki bilgileriniz",
  ca_account_data_desc: "Bu bilgiler hesabınızdan gelir ve burada değiştirilemez.",
  ca_change_in_account: "Yalnızca hesabınızda değiştirebilirsiniz.",
  ca_open_account: "Hesabımı aç",
  ca_missing_data: "Lütfen hesabınızda tamamlayın",
  ca_pick_address: "Adres seçin",
  ca_pick_address_desc: "Kayıtlı bir adres seçin veya yeni ekleyin.",
  ca_error: "Bir şeyler ters gitti. Lütfen tekrar deneyin.",
  ca_loading: "Yükleniyor …",
  ca_checking: "Kontrol ediliyor …",
  ca_cancel: "İptal",
  ca_confirm: "Onayla",
  ca_save: "Kaydet",
  ca_saved: "Tasarruf",
  ca_saved_ok: "Kaydedildi.",
  ca_done: "Tamam",
  ca_copy: "Kopyala",
  ca_download: "Tüm kodları indir",
  ca_or: "veya",
  ca_login: "Giriş yap",
  ca_register: "Kayıt ol",
  ca_logout: "Çıkış yap",
  ca_logout_q: "Çıkış yapılsın mı?",
  ca_logout_text: "Bu cihazda oturumunuz kapatılacak.",
  ca_login_passkey: "Passkey ile giriş yap",
  ca_create_account: "Hesap oluştur",
  ca_my_account: "Hesabım",
  ca_hello: "Merhaba",
  ca_email: "E-posta adresi",
  ca_first_name: "Ad",
  ca_last_name: "Soyad",
  ca_phone: "Telefon",
  ca_password: "Şifre",
  ca_password_repeat: "Şifreyi tekrarla",
  ca_current_password: "Mevcut şifre",
  ca_new_password: "Yeni şifre",
  ca_new_email: "Yeni e-posta adresi",
  ca_pw_rules: "En az 8 karakter, harf ve rakam içermeli.",
  ca_pw_mismatch: "Şifreler eşleşmiyor.",
  ca_pw_changed: "Şifre değiştirildi.",
  ca_change_password: "Şifreyi değiştir",
  ca_forgot: "Şifreni mi unuttun?",
  ca_forgot_title: "Şifremi unuttum",
  ca_forgot_text: "E-posta adresinizi girin. Size sıfırlama bağlantısı göndereceğiz.",
  ca_forgot_done: "Bu adreste bir hesap varsa size bir bağlantı gönderdik.",
  ca_send_link: "Bağlantı gönder",
  ca_back_login: "Girişe dön",
  ca_reset_title: "Yeni şifre belirle",
  ca_reset_done: "Şifreniz değiştirildi. Tüm cihazların oturumu kapatıldı. Girişe yönlendiriliyorsunuz …",
  ca_save_password: "Şifreyi kaydet",
  ca_agb_prefix: "Şunları kabul ediyorum:",
  ca_agb: "Genel Şartlar",
  ca_and: "ve",
  ca_privacy: "Gizlilik Politikası",
  ca_agb_required: "Lütfen şartları ve gizlilik politikasını kabul edin.",
  ca_verified_title: "E-posta adresi onaylandı",
  ca_verified_text: "Teşekkürler! Hesabınız etkinleştirildi, önceki rezervasyonlarınızı artık “Hesabım” altında bulabilirsiniz.",
  ca_to_account: "Hesabıma git",
  ca_link_invalid: "Bağlantı geçersiz veya süresi dolmuş",
  ca_email_changed_title: "E-posta adresi değiştirildi",
  ca_email_changed_text: "E-posta adresiniz değiştirildi. {n} rezervasyon yeni adrese taşındı. Lütfen tekrar giriş yapın.",
  ca_email_change_hint: "Yeni adrese bir onay bağlantısı göndeririz. Ardından rezervasyonlarınız da yeni adrese taşınır.",
  ca_change_email: "E-posta adresini değiştir",
  ca_send_confirm_link: "Onay bağlantısı gönder",
  ca_email_change_sent: "Yeni adrese bir onay bağlantısı gönderdik.",
  ca_banner_verify: "Lütfen e-posta adresinizi onaylayın – size bir e-posta gönderdik. Ancak o zaman rezervasyonlarınızı görür ve puan toplarsınız.",
  ca_resend: "E-postayı yeniden gönder",
  ca_resent: "Onay e-postası yeniden gönderildi.",
  ca_verify_needed: "E-posta adresini onayla",
  ca_verify_needed_text: "E-posta adresinizi onayladığınızda tüm rezervasyonlarınız burada görünür – aynı adresle yapılan eskiler dahil.",
  ca_security_verify_text: "İki adımlı doğrulama ve passkey kurmak için önce e-posta adresinizi onaylayın.",
  ca_my_bookings: "Rezervasyonlarım",
  ca_profile: "Profil",
  ca_security: "Güvenlik",
  ca_upcoming: "Yaklaşan",
  ca_past: "Geçmiş",
  ca_all: "Tümü",
  ca_no_bookings: "Bu görünümde rezervasyon yok.",
  ca_manage: "Yönet",
  ca_round_trip: "Gidiş-dönüş",
  ca_st_planned: "Talep edildi",
  ca_st_planned_accept: "Teklif kabul edildi",
  ca_st_waiting: "Atanıyor",
  ca_st_approved: "Onaylandı",
  ca_st_en_route: "Sürücü yolda",
  ca_st_arrived: "Sürücü geldi",
  ca_st_onboard: "Yolculuk sürüyor",
  ca_st_completed: "Tamamlandı",
  ca_st_cancelled: "İptal edildi",
  ca_st_storno: "İptal edildi",
  ca_st_noshow: "Gelinmedi",
  ca_st_reklamiert: "Şikayet edildi",
  ca_points: "Puan",
  ca_tier_active: "İndiriminiz: tüm yolculuklarda %{p} – tekliflerde otomatik uygulanır.",
  ca_tier_basic_text: "Tamamlanan her yolculukla puan toplayın ve yükselin – %7'ye varan indirim.",
  ca_tier_next: "{name} için {n} puan daha (%{p} indirim)",
  ca_tier_next_trips: "{name} için yaklaşık {trips} yolculuk daha (%{p} indirim) · {n} puan",
  ca_tier_next_trip: "{name} için yaklaşık 1 yolculuk daha (%{p} indirim) · {n} puan",
  ca_tier_max: "En yüksek seviyeye ulaştınız. 🎉",
  ca_tier_discount: "Seviye indirimi",
  ca_2fa_title: "İki adımlı doğrulama",
  ca_2fa_sub: "Hesabınızı bir kimlik doğrulayıcı uygulamasından ek kodla koruyun.",
  ca_2fa_hint: "Kimlik doğrulayıcı uygulamanızdaki 6 haneli kodu girin.",
  ca_2fa_backup_hint: "Yedek kodlarınızdan birini girin. Her kod yalnızca bir kez geçerlidir.",
  ca_code: "Kod",
  ca_backup_code: "Yedek kod",
  ca_code_or_backup: "Uygulamadaki kod veya yedek kod",
  ca_use_backup: "Telefon yanınızda değil mi? Yedek kod kullanın",
  ca_use_app_code: "Bunun yerine uygulamadaki kodu girin",
  ca_2fa_on: "İki adımlı doğrulama etkin",
  ca_2fa_off: "İki adımlı doğrulama kapalı",
  ca_2fa_off_text: "İki adımlı doğrulamayla bir yabancının şifrenizin yanında telefonunuza da ihtiyacı olur.",
  ca_2fa_off_done: "İki adımlı doğrulama kapatıldı.",
  ca_2fa_enable: "Etkinleştir",
  ca_2fa_activate: "Onayla ve etkinleştir",
  ca_2fa_disable: "Kapat",
  ca_2fa_disable_text: "Kapatmak için şifreniz ve geçerli bir kod veya yedek kod gerekir.",
  ca_2fa_scan: "1. QR kodunu kimlik doğrulayıcı uygulamanızla tarayın. 2. Aşağıya 6 haneli kodu girin.",
  ca_2fa_manual: "Veya elle girin",
  ca_new_backup: "Yeni yedek kodlar oluştur",
  ca_backup_left: "Kalan yedek kodlar",
  ca_backup_text: "Bu yedek kodları güvenle saklayın. Yalnızca şimdi gösterilir ve her biri bir kez geçerlidir.",
  ca_each_once: "her kod yalnızca bir kez geçerli",
  ca_checkout_title: "Müşteri hesabı",
  ca_checkout_desc: "Misafir olarak devam edin veya hesap oluşturun – hesapla tüm rezervasyonları görür ve indirim için puan toplarsınız.",
  ca_guest: "Misafir olarak devam et",
  ca_guest_text: "Hesap olmadan hızlı rezervasyon.",
  ca_create_account_text: "Rezervasyonları yönetin, puan toplayın, %7'ye varan indirim.",
  ca_data_taken: "Bu formdaki bilgileriniz kullanılır – yalnızca bir şifre seçmeniz yeterli.",
  ca_continue_guest: "Misafir olarak devam et",
  ca_logged_in_as: "Giriş yapıldı:",
};
const pl = {
  ca_salutation: "Zwrot",
  ca_title: "Tytuł",
  ca_mr: "Pan",
  ca_mrs: "Pani",
  ca_diverse: "Inne",
  ca_name: "Imię i nazwisko",
  ca_profile_hint: "Te dane są automatycznie używane przy każdej rezerwacji i nie można ich tam zmienić – zmień je tutaj.",
  ca_addresses: "Moje adresy",
  ca_addresses_hint: "Przy rezerwacji wybierasz jeden z tych adresów.",
  ca_address: "Adres",
  ca_address_add: "Dodaj adres",
  ca_address_edit: "Edytuj adres",
  ca_address_label: "Nazwa (opcjonalnie)",
  ca_address_label_ph: "np. Dom, Biuro",
  ca_street: "Ulica",
  ca_house_no: "Nr",
  ca_zip: "Kod pocztowy",
  ca_city: "Miejscowość",
  ca_country: "Kraj",
  ca_address_default: "Użyj jako adresu domyślnego",
  ca_default: "Domyślny",
  ca_make_default: "Ustaw jako domyślny",
  ca_edit: "Edytuj",
  ca_delete: "Usuń",
  ca_no_addresses: "Nie zapisano jeszcze adresu.",
  ca_address_delete_q: "Usunąć adres?",
  ca_account_data: "Twoje dane z konta",
  ca_account_data_desc: "Te dane pochodzą z konta i nie można ich tu zmienić.",
  ca_change_in_account: "Możesz je zmienić tylko w koncie.",
  ca_open_account: "Otwórz moje konto",
  ca_missing_data: "Uzupełnij w koncie",
  ca_pick_address: "Wybierz adres",
  ca_pick_address_desc: "Wybierz zapisany adres lub dodaj nowy.",
  ca_error: "Coś poszło nie tak. Spróbuj ponownie.",
  ca_loading: "Ładowanie …",
  ca_checking: "Sprawdzanie …",
  ca_cancel: "Anuluj",
  ca_confirm: "Potwierdź",
  ca_save: "Zapisz",
  ca_saved: "Zaoszczędzono",
  ca_saved_ok: "Zapisano.",
  ca_done: "Gotowe",
  ca_copy: "Kopiuj",
  ca_download: "Pobierz wszystkie kody",
  ca_or: "lub",
  ca_login: "Zaloguj się",
  ca_register: "Zarejestruj się",
  ca_logout: "Wyloguj się",
  ca_logout_q: "Wylogować?",
  ca_logout_text: "Zostaniesz wylogowany na tym urządzeniu.",
  ca_login_passkey: "Zaloguj się kluczem dostępu",
  ca_create_account: "Utwórz konto",
  ca_my_account: "Moje konto",
  ca_hello: "Cześć",
  ca_email: "Adres e-mail",
  ca_first_name: "Imię",
  ca_last_name: "Nazwisko",
  ca_phone: "Telefon",
  ca_password: "Hasło",
  ca_password_repeat: "Powtórz hasło",
  ca_current_password: "Obecne hasło",
  ca_new_password: "Nowe hasło",
  ca_new_email: "Nowy adres e-mail",
  ca_pw_rules: "Co najmniej 8 znaków, litery i cyfra.",
  ca_pw_mismatch: "Hasła nie są takie same.",
  ca_pw_changed: "Hasło zmienione.",
  ca_change_password: "Zmień hasło",
  ca_forgot: "Nie pamiętasz hasła?",
  ca_forgot_title: "Nie pamiętam hasła",
  ca_forgot_text: "Podaj adres e-mail. Wyślemy Ci link do zresetowania hasła.",
  ca_forgot_done: "Jeśli istnieje konto z tym adresem, wysłaliśmy Ci link.",
  ca_send_link: "Wyślij link",
  ca_back_login: "Wróć do logowania",
  ca_reset_title: "Ustaw nowe hasło",
  ca_reset_done: "Hasło zostało zmienione. Wylogowano wszystkie urządzenia. Przekierowanie do logowania …",
  ca_save_password: "Zapisz hasło",
  ca_agb_prefix: "Akceptuję",
  ca_agb: "regulamin",
  ca_and: "oraz",
  ca_privacy: "politykę prywatności",
  ca_agb_required: "Zaakceptuj regulamin i politykę prywatności.",
  ca_verified_title: "Adres e-mail potwierdzony",
  ca_verified_text: "Dziękujemy! Twoje konto jest aktywne. Poprzednie rezerwacje znajdziesz w „Moje konto”.",
  ca_to_account: "Do mojego konta",
  ca_link_invalid: "Link nieprawidłowy lub wygasł",
  ca_email_changed_title: "Adres e-mail zmieniony",
  ca_email_changed_text: "Adres e-mail został zmieniony. {n} rezerwacji przeniesiono na nowy adres. Zaloguj się ponownie.",
  ca_email_change_hint: "Wyślemy link potwierdzający na nowy adres. Następnie Twoje rezerwacje zostaną przeniesione na nowy adres.",
  ca_change_email: "Zmień adres e-mail",
  ca_send_confirm_link: "Wyślij link potwierdzający",
  ca_email_change_sent: "Wysłaliśmy link potwierdzający na nowy adres.",
  ca_banner_verify: "Potwierdź adres e-mail – wysłaliśmy wiadomość. Dopiero wtedy zobaczysz rezerwacje i zbierzesz punkty.",
  ca_resend: "Wyślij e-mail ponownie",
  ca_resent: "Wiadomość potwierdzająca została wysłana ponownie.",
  ca_verify_needed: "Potwierdź adres e-mail",
  ca_verify_needed_text: "Po potwierdzeniu adresu e-mail pojawią się tu wszystkie rezerwacje – także starsze z tym samym adresem.",
  ca_security_verify_text: "Najpierw potwierdź adres e-mail, aby skonfigurować uwierzytelnianie dwuskładnikowe i klucze dostępu.",
  ca_my_bookings: "Moje rezerwacje",
  ca_profile: "Profil",
  ca_security: "Bezpieczeństwo",
  ca_upcoming: "Nadchodzące",
  ca_past: "Przeszłe",
  ca_all: "Wszystkie",
  ca_no_bookings: "Brak rezerwacji w tym widoku.",
  ca_manage: "Zarządzaj",
  ca_round_trip: "Tam i z powrotem",
  ca_st_planned: "Zapytanie",
  ca_st_planned_accept: "Oferta przyjęta",
  ca_st_waiting: "Przypisywanie",
  ca_st_approved: "Potwierdzona",
  ca_st_en_route: "Kierowca w drodze",
  ca_st_arrived: "Kierowca na miejscu",
  ca_st_onboard: "Przejazd trwa",
  ca_st_completed: "Zakończona",
  ca_st_cancelled: "Anulowana",
  ca_st_storno: "Anulowana",
  ca_st_noshow: "Nie stawił się",
  ca_st_reklamiert: "Reklamacja",
  ca_points: "pkt",
  ca_tier_active: "Twój rabat: {p}% na wszystkie przejazdy – automatycznie w ofertach.",
  ca_tier_basic_text: "Zbieraj punkty za każdy zakończony przejazd i awansuj – do 7% rabatu.",
  ca_tier_next: "Jeszcze {n} pkt do poziomu {name} ({p}% rabatu)",
  ca_tier_next_trips: "Jeszcze ok. {trips} przejazdów do {name} ({p}% rabatu) · {n} pkt",
  ca_tier_next_trip: "Jeszcze ok. 1 przejazd do {name} ({p}% rabatu) · {n} pkt",
  ca_tier_max: "Osiągnięto najwyższy poziom. 🎉",
  ca_tier_discount: "Rabat za poziom",
  ca_2fa_title: "Uwierzytelnianie dwuskładnikowe",
  ca_2fa_sub: "Chroń konto dodatkowym kodem z aplikacji uwierzytelniającej.",
  ca_2fa_hint: "Wpisz 6-cyfrowy kod z aplikacji uwierzytelniającej.",
  ca_2fa_backup_hint: "Wpisz jeden z kodów zapasowych. Każdy kod działa tylko raz.",
  ca_code: "Kod",
  ca_backup_code: "Kod zapasowy",
  ca_code_or_backup: "Kod z aplikacji lub kod zapasowy",
  ca_use_backup: "Brak telefonu? Użyj kodu zapasowego",
  ca_use_app_code: "Zamiast tego wpisz kod z aplikacji",
  ca_2fa_on: "Uwierzytelnianie dwuskładnikowe aktywne",
  ca_2fa_off: "Uwierzytelnianie dwuskładnikowe wyłączone",
  ca_2fa_off_text: "Przy uwierzytelnianiu dwuskładnikowym obcy potrzebuje oprócz hasła także Twojego telefonu.",
  ca_2fa_off_done: "Uwierzytelnianie dwuskładnikowe wyłączono.",
  ca_2fa_enable: "Włącz",
  ca_2fa_activate: "Potwierdź i aktywuj",
  ca_2fa_disable: "Wyłącz",
  ca_2fa_disable_text: "Aby wyłączyć, potrzebujesz hasła i aktualnego kodu lub kodu zapasowego.",
  ca_2fa_scan: "1. Zeskanuj kod QR aplikacją uwierzytelniającą. 2. Wpisz poniżej 6-cyfrowy kod.",
  ca_2fa_manual: "Lub wpisz ręcznie",
  ca_new_backup: "Wygeneruj nowe kody zapasowe",
  ca_backup_left: "Pozostałe kody zapasowe",
  ca_backup_text: "Przechowaj te kody zapasowe bezpiecznie. Widać je tylko teraz, każdy działa raz.",
  ca_each_once: "każdy kod działa tylko raz",
  ca_checkout_title: "Konto klienta",
  ca_checkout_desc: "Kontynuuj jako gość lub utwórz konto – z kontem widzisz wszystkie rezerwacje i zbierasz punkty na rabaty.",
  ca_guest: "Kontynuuj jako gość",
  ca_guest_text: "Szybka rezerwacja bez konta.",
  ca_create_account_text: "Zarządzaj rezerwacjami, zbieraj punkty, do 7% rabatu.",
  ca_data_taken: "Twoje dane z tego formularza zostaną użyte – wystarczy wybrać hasło.",
  ca_continue_guest: "Kontynuuj jako gość",
  ca_logged_in_as: "Zalogowano jako",
};
const uk = {
  ca_salutation: "Звернення",
  ca_title: "Титул",
  ca_mr: "Пан",
  ca_mrs: "Пані",
  ca_diverse: "Інше",
  ca_name: "Ім'я",
  ca_profile_hint: "Ці дані автоматично використовуються під час кожного бронювання й не змінюються там – змінюйте їх тут.",
  ca_addresses: "Мої адреси",
  ca_addresses_hint: "Під час бронювання ви обираєте одну з цих адрес.",
  ca_address: "Адреса",
  ca_address_add: "Додати адресу",
  ca_address_edit: "Редагувати адресу",
  ca_address_label: "Назва (необов'язково)",
  ca_address_label_ph: "напр. Дім, Офіс",
  ca_street: "Вулиця",
  ca_house_no: "№",
  ca_zip: "Індекс",
  ca_city: "Місто",
  ca_country: "Країна",
  ca_address_default: "Використовувати як основну",
  ca_default: "Основна",
  ca_make_default: "Зробити основною",
  ca_edit: "Редагувати",
  ca_delete: "Видалити",
  ca_no_addresses: "Адресу ще не збережено.",
  ca_address_delete_q: "Видалити адресу?",
  ca_account_data: "Ваші дані з акаунта",
  ca_account_data_desc: "Ці дані беруться з акаунта й не змінюються тут.",
  ca_change_in_account: "Змінити їх можна лише в акаунті.",
  ca_open_account: "Відкрити мій акаунт",
  ca_missing_data: "Доповніть в акаунті",
  ca_pick_address: "Оберіть адресу",
  ca_pick_address_desc: "Оберіть збережену адресу або додайте нову.",
  ca_error: "Щось пішло не так. Спробуйте ще раз.",
  ca_loading: "Завантаження …",
  ca_checking: "Перевірка …",
  ca_cancel: "Скасувати",
  ca_confirm: "Підтвердити",
  ca_save: "Зберегти",
  ca_saved: "Заощаджено",
  ca_saved_ok: "Збережено.",
  ca_done: "Готово",
  ca_copy: "Копіювати",
  ca_download: "Завантажити всі коди",
  ca_or: "або",
  ca_login: "Увійти",
  ca_register: "Реєстрація",
  ca_logout: "Вийти",
  ca_logout_q: "Вийти?",
  ca_logout_text: "Ви вийдете з акаунта на цьому пристрої.",
  ca_login_passkey: "Увійти з passkey",
  ca_create_account: "Створити акаунт",
  ca_my_account: "Мій акаунт",
  ca_hello: "Вітаємо,",
  ca_email: "Адреса e-mail",
  ca_first_name: "Ім'я",
  ca_last_name: "Прізвище",
  ca_phone: "Телефон",
  ca_password: "Пароль",
  ca_password_repeat: "Повторіть пароль",
  ca_current_password: "Поточний пароль",
  ca_new_password: "Новий пароль",
  ca_new_email: "Нова адреса e-mail",
  ca_pw_rules: "Щонайменше 8 символів, літери та цифра.",
  ca_pw_mismatch: "Паролі не збігаються.",
  ca_pw_changed: "Пароль змінено.",
  ca_change_password: "Змінити пароль",
  ca_forgot: "Забули пароль?",
  ca_forgot_title: "Забули пароль",
  ca_forgot_text: "Введіть свою адресу e-mail. Ми надішлемо посилання для скидання.",
  ca_forgot_done: "Якщо акаунт із цією адресою існує, ми надіслали вам посилання.",
  ca_send_link: "Надіслати посилання",
  ca_back_login: "Назад до входу",
  ca_reset_title: "Встановіть новий пароль",
  ca_reset_done: "Пароль змінено. Усі пристрої вийшли з акаунта. Перенаправлення на вхід …",
  ca_save_password: "Зберегти пароль",
  ca_agb_prefix: "Я приймаю",
  ca_agb: "умови",
  ca_and: "та",
  ca_privacy: "політику конфіденційності",
  ca_agb_required: "Прийміть умови та політику конфіденційності.",
  ca_verified_title: "Адресу e-mail підтверджено",
  ca_verified_text: "Дякуємо! Ваш акаунт активовано. Попередні бронювання тепер у розділі «Мій акаунт».",
  ca_to_account: "До мого акаунта",
  ca_link_invalid: "Посилання недійсне або прострочене",
  ca_email_changed_title: "Адресу e-mail змінено",
  ca_email_changed_text: "Адресу e-mail змінено. Бронювань перенесено на нову адресу: {n}. Увійдіть знову.",
  ca_email_change_hint: "Ми надішлемо посилання для підтвердження на нову адресу. Після цього ваші бронювання також буде переведено на неї.",
  ca_change_email: "Змінити адресу e-mail",
  ca_send_confirm_link: "Надіслати посилання",
  ca_email_change_sent: "Ми надіслали посилання для підтвердження на нову адресу.",
  ca_banner_verify: "Підтвердіть адресу e-mail – ми надіслали лист. Лише тоді ви побачите бронювання та збиратимете бали.",
  ca_resend: "Надіслати лист ще раз",
  ca_resent: "Лист із підтвердженням надіслано ще раз.",
  ca_verify_needed: "Підтвердіть адресу e-mail",
  ca_verify_needed_text: "Після підтвердження адреси e-mail тут з'являться всі ваші бронювання, зокрема старіші з тією самою адресою.",
  ca_security_verify_text: "Спершу підтвердіть адресу e-mail, щоб налаштувати двофакторну автентифікацію та passkey.",
  ca_my_bookings: "Мої бронювання",
  ca_profile: "Профіль",
  ca_security: "Безпека",
  ca_upcoming: "Майбутні",
  ca_past: "Минулі",
  ca_all: "Усі",
  ca_no_bookings: "У цьому розділі немає бронювань.",
  ca_manage: "Керувати",
  ca_round_trip: "Туди й назад",
  ca_st_planned: "Запит",
  ca_st_planned_accept: "Пропозицію прийнято",
  ca_st_waiting: "Призначається",
  ca_st_approved: "Підтверджено",
  ca_st_en_route: "Водій в дорозі",
  ca_st_arrived: "Водій на місці",
  ca_st_onboard: "Поїздка триває",
  ca_st_completed: "Завершено",
  ca_st_cancelled: "Скасовано",
  ca_st_storno: "Скасовано",
  ca_st_noshow: "Не з'явився",
  ca_st_reklamiert: "Скарга",
  ca_points: "балів",
  ca_tier_active: "Ваша знижка: {p}% на всі поїздки – автоматично в пропозиціях.",
  ca_tier_basic_text: "Збирайте бали за кожну завершену поїздку та підвищуйте рівень – знижка до 7%.",
  ca_tier_next: "Ще {n} балів до рівня {name} (знижка {p}%)",
  ca_tier_next_trips: "Ще приблизно {trips} поїздок до {name} (знижка {p}%) · {n} балів",
  ca_tier_next_trip: "Ще приблизно 1 поїздка до {name} (знижка {p}%) · {n} балів",
  ca_tier_max: "Ви досягли найвищого рівня. 🎉",
  ca_tier_discount: "Знижка за рівень",
  ca_2fa_title: "Двофакторна автентифікація",
  ca_2fa_sub: "Захистіть акаунт додатковим кодом із застосунку-автентифікатора.",
  ca_2fa_hint: "Введіть 6-значний код із застосунку-автентифікатора.",
  ca_2fa_backup_hint: "Введіть один із резервних кодів. Кожен код діє лише раз.",
  ca_code: "Код",
  ca_backup_code: "Резервний код",
  ca_code_or_backup: "Код із застосунку або резервний код",
  ca_use_backup: "Немає телефону? Використайте резервний код",
  ca_use_app_code: "Натомість введіть код із застосунку",
  ca_2fa_on: "Двофакторну автентифікацію ввімкнено",
  ca_2fa_off: "Двофакторну автентифікацію вимкнено",
  ca_2fa_off_text: "З двофакторною автентифікацією стороннім потрібен і ваш телефон, і пароль.",
  ca_2fa_off_done: "Двофакторну автентифікацію вимкнено.",
  ca_2fa_enable: "Увімкнути",
  ca_2fa_activate: "Підтвердити та активувати",
  ca_2fa_disable: "Вимкнути",
  ca_2fa_disable_text: "Щоб вимкнути, потрібні пароль і поточний або резервний код.",
  ca_2fa_scan: "1. Скануйте QR-код застосунком. 2. Введіть нижче 6-значний код.",
  ca_2fa_manual: "Або введіть вручну",
  ca_new_backup: "Створити нові резервні коди",
  ca_backup_left: "Залишилось резервних кодів",
  ca_backup_text: "Збережіть ці резервні коди. Їх показано лише зараз, кожен діє один раз.",
  ca_each_once: "кожен код діє лише раз",
  ca_checkout_title: "Акаунт клієнта",
  ca_checkout_desc: "Продовжте як гість або створіть акаунт – з акаунтом ви бачите всі бронювання та збираєте бали на знижки.",
  ca_guest: "Продовжити як гість",
  ca_guest_text: "Швидке бронювання без акаунта.",
  ca_create_account_text: "Керуйте бронюваннями, збирайте бали, знижка до 7%.",
  ca_data_taken: "Дані з цієї форми буде використано – потрібно лише обрати пароль.",
  ca_continue_guest: "Продовжити як гість",
  ca_logged_in_as: "Ви увійшли як",
};
export default { de, en, tr, pl, uk };
